module.exports = __webpack_public_path__ + "c459142c3ab9d3041a36371805a42fe9.svg";